export interface Student {
    id: number
    name: string
    email: string
    phone_number: string
    password: string
    password_repeat: string
    country: string
    state: number
    lga: number
}

export function newStudent(): Student {
    return {
        id: 0,
        name: '',
        email: '',
        phone_number: '',
        password: '',
        password_repeat: '',
        country: 'NG',
        state: 0,
        lga: 0
    };
}

export function createStudentPayload(student: Student) {
    return {
        name: student.name,
        email: student.email,
        phone_number: student.phone_number,
        password: student.password,
        country: student.country,
        state: student.state,
        lga: student.lga
    }
}